import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../colorVars';
import { Body2 } from '../../../../../atomic/text/Text';
import style from './WatchlistManagerListComponent.module.css';

export const WatchlistManagerListComponent = ({
  watchlistName,
  selectedWatchlist,
  setSelectedWatchlist,
}) => {
  return (
    <div
      className={
        selectedWatchlist === watchlistName
          ? style.selectedContainer
          : style.container
      }
      onClick={() => setSelectedWatchlist(watchlistName)}
    >
      <Body2 fontWeight={700} color={colors.lightGrey}>
        {watchlistName}
      </Body2>
    </div>
  );
};

WatchlistManagerListComponent.propTypes = {
  selectedWatchlist: PropTypes.any,
  setSelectedWatchlist: PropTypes.func,
  watchlistName: PropTypes.any
};
